import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SecAdminUserService } from "../../services/sec-admin-user.service";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styles: [],
    standalone: false
})
export class LoginComponent implements OnInit {
  public errorMessage: string;

  constructor(private readonly titleService: Title, private readonly secAdminUserService: SecAdminUserService, private readonly route: ActivatedRoute, private readonly router: Router) { }

  ngOnInit(): void {
    this.titleService.setTitle("Sign In");

    this.secAdminUserService.login()
      .subscribe(succeeded => {
        if (succeeded) {
          this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
        } else {
          this.errorMessage = "Unknown error during sign in.";
        }
      }, error => {
        this.errorMessage = error.message;
      });
  }

}
